// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedPlan: null
}

const plans = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_PLANS':
      return { ...state, allData: action.data, selectedPlan: null}
    case 'GET_DATA_PLAN':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_PLAN':
      console.log('action.selectedPlan', action.selectedPlan);
      return { ...state, selectedPlan: action.selectedPlan }
    case 'ADD_PLAN':
      return { ...state }
    case 'DELETE_PLAN':
      return { ...state }
    default:
      return { ...state }
  }
}
export default plans

